import React, { useState, useEffect, useRef } from 'react';
import "./SignUpPage.css"
import {
    registerUser,
    sendVerificationCode,
    verifyEmailCode,
    checkUserIdDuplicate,
  } from '../../api/publicApi'
  import { useNavigate } from "react-router-dom"; // ✅ 추가

const SignupPage = () => {
  const navigate = useNavigate(); // ✅ 라우터 이동 훅
    const [form, setForm] = useState({
        userId: '',
        password: '',
        passwordCheck: '',
        name: '',
        company: '',
        tel: '',
        verificationCode: '',
        privacyConsent: false,      // ✅ 개인정보 수집 동의 (필수)
        marketingConsent: false,    // ✅ 마케팅 수신 동의 (선택)
      })
    
      const [errorMsg, setErrorMsg] = useState('')
      const [emailVerified, setEmailVerified] = useState(false)
      const [isUserIdAvailable, setIsUserIdAvailable] = useState(null)
      const [checkingDuplicate, setCheckingDuplicate] = useState(false)

      const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        setForm((prev) => ({
          ...prev,
          [name]: type === 'checkbox' ? checked : value,
        }))
    
        if (name === 'userId') {
          setIsUserIdAvailable(null)
          setEmailVerified(false)
        }
      }
    
      const handleCheckDuplicate = async () => {
        setErrorMsg('')
        if (!form.userId) {
          setErrorMsg('아이디(이메일)를 입력해주세요.')
          return
        }
    
        setCheckingDuplicate(true)
        try {
          const result = await checkUserIdDuplicate(form.userId)
          console.log('checkUserIdDuplicate 결과:', result)
          if (!result.data) {
            setIsUserIdAvailable(true)
            alert(result.message)
          } else {
            setIsUserIdAvailable(false)
            alert(result.message)
          }
        } catch (err) {
          setErrorMsg('중복 확인 중 오류가 발생했습니다.')
          console.error(err)
        } finally {
          setCheckingDuplicate(false)
        }
      }
    
      const handleEmailVerification = async () => {
        setErrorMsg('')
    
        if (!form.userId) {
          setErrorMsg('이메일을 입력해주세요.')
          return
        }
    
        if (isUserIdAvailable === null) {
          setErrorMsg('아이디 중복 확인을 먼저 해주세요.')
          return
        }
    
        if (isUserIdAvailable === true) {
          setErrorMsg('중복된 아이디는 인증을 진행할 수 없습니다.')
          return
        }
    
        try {
          const result = await sendVerificationCode({ email: form.userId })
    
          if (result.status === 200) {
            alert(result.message || '이메일 인증 코드가 발송되었습니다.')
            setEmailVerified(false)
          } else {
            setErrorMsg('이메일 인증 코드 발송 실패: ' + result.message)
          }
        } catch (err) {
          console.error(err)
          const message = err.response?.data?.message || '서버 오류가 발생했습니다.'
          alert(message)
        }
      }
    
      const handleVerifyCode = async () => {
        setErrorMsg('')
    
        if (form.verificationCode.trim() === '') {
          setErrorMsg('인증 코드를 입력해주세요.')
          return
        }
    
        try {
          const result = await verifyEmailCode({
            email: form.userId,
            inputCode: form.verificationCode,
          })
    
          if (result.status === 200) {
            alert(result.message || '이메일 인증이 완료되었습니다.')
            setEmailVerified(true)
          } else {
            setErrorMsg('인증 코드가 잘못되었습니다.')
          }
        } catch (err) {
          console.error(err)
          const message = err.response?.data?.message || '서버 오류가 발생했습니다.'
          alert(message)
        }
      }
    
      const handleSubmit = async (e) => {
        e.preventDefault() 
        setErrorMsg('')
    
        if (form.password !== form.passwordCheck) {
          setErrorMsg('비밀번호가 일치하지 않습니다.')
          return
        }

        // if (form.company) {
        //   setErrorMsg('회사를 입력해주세요.')
        //   return
        // }
    
        if (!form.name) {
          setErrorMsg('이름을 입력해주세요.')
          return
        }
    
        if (!form.privacyConsent) {
          setErrorMsg('개인정보 수집에 동의하셔야 합니다.')
          return
        }
    
        if (isUserIdAvailable === null) {
          setErrorMsg('아이디 중복 확인을 해주세요.')
          return
        }
    
        if (isUserIdAvailable === true) {
          setErrorMsg('중복된 아이디는 사용할 수 없습니다.')
          return
        }
    
        if (!emailVerified) {
          setErrorMsg('이메일 인증을 완료해주세요.')
          return
        }
    
        try {
          const result = await registerUser({
            userId: form.userId,
            password: form.password,
            name: form.name,
            company: form.company,
            tel: form.tel || null,
            privacyConsent: form.privacyConsent,       // ✅ 추가
            marketingConsent: form.marketingConsent,   // ✅ 추가
          })
    
          if (result.status === 200) {
            alert(result.message || '회원가입 성공!')
            // 리다이렉트 또는 초기화 등 추가 작업
          } else {
            setErrorMsg('회원가입 실패: ' + result.message)
          }
        } catch (err) {
          console.error(err)
          const message = err.response?.data?.message || '서버 오류가 발생했습니다.'
          alert(message)
        }
      }
      
  return (
   <div className='Signupcontainer'>
    <div className='background'/>
    <div className='Signupcomponent'>
    
   
        <div className='Signup_TitleContainer'>
            Sign up
        </div>
         
        <form onSubmit={handleSubmit}>
        <input 
            type="email" 
            name="userId"
            className='Signup_NameTextFelid'
            required 
            placeholder="E-mail address" 
            value={form.userId}
            onChange={handleChange}
        />
          <button
          type="button"
          onClick={handleCheckDuplicate}
          disabled={checkingDuplicate}
            >
            {checkingDuplicate ? '확인 중...' : '중복 확인'}
            </button>
        {/* {isUserIdAvailable !== null && (
          <p style={{ color: isUserIdAvailable ? 'red' : 'green' }}>
            {isUserIdAvailable
              ? '사용 중인 아이디입니다.'
              : '사용 가능한 아이디입니다!'}
          </p>
        )} */}
          
        <input
          type="password"
          name="password"
          placeholder="비밀번호"
          className='Signup_NameTextFelid'
          value={form.password}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type="password"
          name="passwordCheck"
          placeholder="비밀번호 확인"
          className='Signup_NameTextFelid'
          value={form.passwordCheck}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type="text"
          name="name"
          placeholder="이름"
          className='Signup_NameTextFelid'
          value={form.name}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type="text"
          name="company"
          placeholder="회사"
          className='Signup_NameTextFelid'
          value={form.company}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type="tel"
          name="tel"
          placeholder="전화번호"
          className='Signup_NameTextFelid'
          value={form.tel}
          onChange={handleChange}
        />
        <br />
        <button type="button" onClick={handleEmailVerification}>
          이메일 인증 코드 발송
        </button>
        <br />
        <input
          type="text"
          name="verificationCode"
          placeholder="인증 코드"
          className='Signup_NameTextFelid'
          value={form.verificationCode}
          onChange={handleChange}
          required
        />
        <button type="button" onClick={handleVerifyCode}>
          인증 코드 확인
        </button>
        <br />

        {/* ✅ 동의 체크박스 */}
        <label>
          <input
            type="checkbox"
            name="privacyConsent"
            checked={form.privacyConsent}
            onChange={handleChange}
            required
          />
          개인정보 수집 및 이용에 동의합니다. (필수)
        </label>
        <br />
        <label>
          <input
            type="checkbox"
            name="marketingConsent"
            checked={form.marketingConsent}
            onChange={handleChange}
          />
          마케팅 정보 수신에 동의합니다. (선택)
        </label>
        {errorMsg && (
        <div style={{ color: 'red', marginTop: '1rem' }}>{errorMsg}</div>
      )}

      {emailVerified && (
        <div style={{ color: 'green', marginTop: '1rem' }}>
          이메일 인증 완료!
        </div>
      )}
        </form>
        <div>

        </div>
        <div className='Signupbtn' onClick={handleSubmit}>
            <h3>Sign up</h3>
        </div>
        <div className='signuplinkContainer'>
            <div>
            Do you have an account?
            </div>
            <div className='signuplink' onClick={() => navigate("/login")}>
            Login
            </div>
        </div>
    </div>

   </div>
  );
};

export default SignupPage;


